import {
  alpha,
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import theme, { responsiveFontSize } from "themes/Theme";
import { Link, useNavigate } from "react-router-dom";
import InstagramIcon from "assets/svg/InstagramIcon";
import FacebookIcon from "assets/svg/FacebookIcon";
import { Logo } from "assets/index";

interface IProps {
  isMobile: boolean;
}

const Footer: React.FC<IProps> = ({ isMobile }) => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        borderTop: "1px solid rgba(15, 80, 81, 0.6)",
      }}
    >
      <Container sx={styles.container}>
        {/* <Box sx={styles.newsLetterContainer}>
          <Box>
            <Typography sx={styles.newsLetterTitle}>
              Stay Connected with Our Newsletter
            </Typography>
            <Typography sx={styles.newsLetterDescription}>
              Subscribe to our newsletter to get more news, promo, or news
              services
            </Typography>
          </Box>
          <Box sx={styles.inputContainer}>
            <TextField
              variant="standard"
              placeholder="Enter email address"
              slotProps={{
                input: {
                  disableUnderline: true,
                  sx: {
                    color: "white",
                    "::placeholder": {
                      color: "rgba(232, 232, 232, 1)",
                      opacity: 1,
                    },
                  },
                },
              }}
              sx={{ backgroundColor: "transparent", width: "15em" }}
            />
            <Button variant="contained" sx={styles.subscribeBtnStyle}>
              <Typography sx={styles.subscribeBtnText}>Subscribe</Typography>
            </Button>
          </Box>
        </Box> */}
        <Box sx={styles.footerLinksContainer}>
          <Box sx={{ maxWidth: isMobile ? "100%" : "40%" }}>
            <Stack direction={"row"} alignItems={"center"} gap={1}>
              <Box
                component={"img"}
                src={Logo}
                alt="logo"
                sx={styles.brandLogo}
                onClick={() => {
                  navigate("/");
                }}
              />
              <Typography sx={styles.footerBrandTitle}>
                ERC Webwellet
              </Typography>
            </Stack>
            <Typography sx={styles.brandDescription}>
              ERC Webwellet is a secure digital wallet designed exclusively for
              the Carbon Plant Project. Built on blockchain technology, it
              facilitates the storage, transfer, and management of Emission
              Reduction Coins (ERCs).
            </Typography>
            {/* <Stack direction={"row"} alignItems={"center"} gap={2} mt={2}>
              <IconButton>
                <InstagramIcon />
              </IconButton>
              <IconButton>
                <FacebookIcon />
              </IconButton>
            </Stack> */}
          </Box>
          <Box>
            <Stack direction={{ xs: "column", sm: "row" }} gap={8}>
              <List>
                <ListItem disablePadding>
                  <ListItemText sx={styles.listItemTextHeading}>
                    Company
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemText>
                    <Link to={"/about-us"} style={styles.listItemTextLink}>
                      About Us
                    </Link>
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemText>
                    <Link to={"/faq"} style={styles.listItemTextLink}>
                      FAQ
                    </Link>
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemText>
                    <Link to={"/contact-us"} style={styles.listItemTextLink}>
                      Contact
                    </Link>
                  </ListItemText>
                </ListItem>
              </List>
              <List>
                <ListItem disablePadding>
                  <ListItemText sx={styles.listItemTextHeading}>
                    Legal
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemText>
                    <Link
                      to={"/terms-condition"}
                      style={styles.listItemTextLink}
                    >
                      Terms & Condition
                    </Link>
                  </ListItemText>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemText>
                    <Link
                      to={"/privacy-policy"}
                      style={styles.listItemTextLink}
                    >
                      Privacy Policy
                    </Link>
                  </ListItemText>
                </ListItem>
              </List>
            </Stack>
          </Box>
        </Box>
      </Container>
      <Divider flexItem sx={{ borderColor: "rgba(0, 0, 0, 0.1)" }} />
      <center>
        <Typography sx={styles.copyrightText}>
          ERC Webwellet &copy; {new Date().getFullYear()} . All rights reserved
        </Typography>
      </center>
    </Box>
  );
};
export default Footer;
const styles = {
  container: {
    py: 4,
  },
  newsLetterContainer: {
    backgroundColor: alpha(theme.palette.primary.light, 0.2),
    borderRadius: "1.875em",
    padding: "1.125em",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: "space-between",
    alignItems: "center",
    gap: 4,
  },
  footerBrandTitle: {
    fontSize: responsiveFontSize(18),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  newsLetterTitle: {
    fontSize: responsiveFontSize(18),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  newsLetterDescription: {
    fontSize: responsiveFontSize(12),
    fontWeight: 400,
    color: theme.palette.text.primary,
  },
  inputContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "2.813rem",
    padding: "0.563em",
  },
  subscribeBtnStyle: {
    backgroundColor: theme.palette.custom?.white,
    borderRadius: "2.813em",
  },
  subscribeBtnText: {
    color: theme.palette.text.primary,
    fontSize: responsiveFontSize(12),
    fontWeight: 400,
    textTransform: "none",
  },
  footerLinksContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
  },
  logoText: {
    fontSize: responsiveFontSize(24),
    fontWeight: 400,
    color: theme.palette.primary.light,
    "& span": {
      color: theme.palette.primary.main,
    },
  },
  brandDescription: {
    fontSize: responsiveFontSize(12),
    color: theme.palette.text.primary,
    fontWeight: 400,
    marginTop: "10px",
  },
  listItemTextHeading: {
    fontSize: responsiveFontSize(18),
    color: theme.palette.text.primary,
    fontWeight: 400,
  },
  copyrightText: {
    fontSize: responsiveFontSize(12),
    color: theme.palette.text.primary,
    fontWeight: 400,
    py: 2,
  },
  listItemTextLink: {
    fontSize: responsiveFontSize(15),
    color: theme.palette.text.primary,
    fontWeight: 400,
    textDecoration: "none",
  },
  brandLogo: {
    width: 50,
    height: 50,
    objectFit: "contain",
    "&:hover": {
      cursor: "pointer",
    },
  },
};
